import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ColDef, DomLayoutType, GridApi, GridOptions, GridReadyEvent, IRowNode } from 'ag-grid-community';
import { PaginationPageSizes } from 'src/app/constants';
import { CustomerEnabledUsersDataModel } from 'src/app/features/store/models/storeModel';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss']
})
export class CustomersListComponent implements OnInit, OnChanges {

  @Input() rowData: any;

  @Input() tableConfigOptions: any;

  @Input() anyChange: boolean;

  @Input() allUsersSearchText: string;

  @Input() configOptionsOnChanges: any;

  @Input() rowSelection: any;

  @Input() customerEnabledUsers: CustomerEnabledUsersDataModel[];

  gridApi: GridApi;

  // public frameworkComponents: any;

  @Output() rowSelectedEvent = new EventEmitter();

  @Output() rowEditedEvent = new EventEmitter();

  gridOptions: GridOptions;

  // rowSelection: "single" | "multiple" = "multiple";

  selectedRows: any;

  public columnDefs: ColDef[];

  public defaultColDef: ColDef = {
    sortable: true,
    minWidth: 120
  };

  public domLayout: DomLayoutType;

  style: any = {
    width: '100%',
    height: '100%'
  };

  public paginationPageSize = 10;

  paginationPageSizes = PaginationPageSizes;


  constructor(private sharedService: SharedService) { }

  ngOnInit(): void {
    this.compInit();
  }

  compInit() {
    this.columnDefs = [
      {
        headerName: 'User',
        // headerCheckboxSelection: this.tableConfigOptions.headerCheckboxSelection ? this.tableConfigOptions.headerCheckboxSelection : false,
        field: 'user',
        sort: 'asc',
        comparator: this.sharedService.numberComparator,
        checkboxSelection: true,
      },
      {
        headerName: 'Name',
        valueGetter: params => {
          return this.sharedService.getFullNameForUsers(params);
        },
        comparator: this.sharedService.textComparator
      },
      {
        headerName: 'Scope',
        field: 'scope',
        comparator: this.sharedService.textComparator
      },
    ];
    this.gridOptions = {
      components: {

      },
      defaultColDef: this.defaultColDef,
      animateRows: true,
      // rowSelection: this.rowSelection,
      isRowSelectable: (rowNode: IRowNode) => {
        const abcd = this.customerEnabledUsers.some(item => {
          return item.user === rowNode.data.user;
        });
        if (abcd) {
          return false
        } else {
          return true;
        }
      },
      suppressRowClickSelection: true,
      pagination: true,
      paginationPageSize: this.paginationPageSize,
      alwaysShowHorizontalScroll: false,
      context: { componentParent: this },
      onRowSelected: ($event) => {
        this.onRowSelected($event)
      },
      onRowDoubleClicked: ($event) => {
        this.onRowDoubleClicked($event);
      },
      onSortChanged: () => {
        // const sortModel = this.gridApi.getSortModel()[0];
        // if (sortModel) {

        // }
      },
      onFilterChanged: () => {
        // const filterModel = this.gridApi.getFilterModel();
      }
    }
    this.operateTableConfigs();
  }

   checkHeaderCheckBoxSeletion() {
    return (this.rowSelection === 'multiple' && this.tableConfigOptions.headerCheckboxSelection)
  }

  operateTableConfigs() {
    this.domLayout = (this.tableConfigOptions && this.tableConfigOptions.domLayoutType) ? this.tableConfigOptions.domLayoutType : 'autoHeight';
    if (this.tableConfigOptions) {
      if (this.tableConfigOptions.columns && this.tableConfigOptions.columns.length)
        this.tableConfigOptions.columns.forEach((item: any) => {
          this.columnDefs.forEach(column => {
            if (item.headerName === column.headerName) {
              column.hide = item.hide;
            }
          });
        });
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.setColumnDefs(this.columnDefs);
    params.api.sizeColumnsToFit();
  }

  onRowSelected(event: any) {
    this.getSelectedRows();
  }

  getSelectedRows() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    this.selectedRows = selectedNodes.map(node => node.data);
    this.rowSelectedEvent.emit(this.selectedRows);
  }

  onRowDoubleClicked(event: any) {
    // this.rowEditedEvent.emit(event.data);
  }

  clearRowSelection() {
    if (this.gridApi) {
      this.gridApi.deselectAll();
    }
  }

  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  }

  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.anyChange && this.gridApi) {
      this.gridApi.sizeColumnsToFit();
      this.anyChange = false;
    }

    // if (this.customerEnabledUsers && this.gridApi) {
    //   this.gridApi.setRowData(this.rowData);
    // }

    if (this.allUsersSearchText && this.gridApi) {
      this.gridApi.setQuickFilter(this.allUsersSearchText)
    } else if (!this.allUsersSearchText && this.gridApi) {
      this.gridApi.setQuickFilter('')
    }

    if (this.configOptionsOnChanges && this.configOptionsOnChanges.isClearSelection) {
      this.gridApi.setRowData(this.rowData);
      this.clearRowSelection();
      this.configOptionsOnChanges.isClearSelection = false;
    }

    if (this.rowSelection && this.gridOptions) {
      const currentColumnDefs = this.gridOptions.api?.getColumnDefs();
      if (currentColumnDefs) {
        const updatedColumnDefs = currentColumnDefs.map((colDef: any) => {
          if (colDef.field === 'user') {
            return { ...colDef, headerCheckboxSelection: this.checkHeaderCheckBoxSeletion() }; // Example modification
          }
          return colDef;
        });
        this.gridOptions.api?.setColumnDefs(updatedColumnDefs);
      }
    }
  }

}
